module.exports = __webpack_public_path__ + "img/Truck-Outline.adcae8d7.png";